module.exports = __webpack_public_path__ + "img/2recr_comuni.c5a4c6eb.png";